import "./form-quote-activity.scss";

import { QuoteActivityFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = QuoteActivityFormSchema;
export function FormQuoteActivity() {
  const { control } = useFormContext<QuoteActivityFormSchema>();
  return (
    <div id="FormQuoteActivity" className="quote-activity">
      <InputControl<InputFormSchema>
        control={control}
        name="baseActivity"
        label="Base Activity"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter baseActivity"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="quotation"
        label="Quotation"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter quotation"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isModified"
        label="Is Modified"
        containerClassName="pb-2"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="day"
        label="Day"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter day"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isChildActivity"
        label="Is Child Activity"
        containerClassName="pb-2"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="childRate"
        label="Child Rate"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter childRate"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="showAsOptional"
        label="Show As Optional"
        containerClassName="pb-2"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isFree"
        label="Is Free"
        containerClassName="pb-2"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="entranceFee"
        label="Entrance Fee"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter entranceFee"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="numPeople"
        label="Num People"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter numPeople"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="unit"
        label="Unit"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter unit"
      />
    </div>
  );
}

export default FormQuoteActivity;
